
// vee-validateメッセージ定義
import en from "@vee-validate/i18n/dist/locale/en.json";
import ja from "@vee-validate/i18n/dist/locale/ja.json";

const getCombinedMessages = () => {
	// 共通メッセージ
	let comMsg = { en:{}, ja:{} };

	// メッセージ定義全取得
	const context = require.context('../assets/messages', true, /([a-z_-]+)\.json$/i);
	const messages = {};

	// メッセージ定義を格納 ( 例: {loginMsg: "..."} 定義のキーは拡張子を除いたファイル名)
	context.keys().forEach(key => {
		let fileName = key.match(/([a-z_-]+)\.json$/i)[1];
		if(fileName === 'commonMsg'){
			comMsg = context(key);
		} else {
			messages[fileName] = context(key);
		}
	});

	// comMsgにメッセージ定義をマージする
	Object.keys(messages).forEach(key => {
		comMsg.en[key] = messages[key].en;
		comMsg.ja[key] = messages[key].ja;
	});
	// vee-validateメッセージのマージ
	const mergeVeeValidateMst = (lang, msg) => {
		if(!comMsg[lang]){
			comMsg[lang] = {};
		}
		if(!comMsg[lang].validationMsg){
			comMsg[lang].validationMsg = {};
		}
		if(!comMsg[lang].validationMsg.messages){
			comMsg[lang].validationMsg.messages = {};
		}
		Object.keys(msg).forEach(key => {
			comMsg[lang].validationMsg.messages[key] = msg[key];
		});
	};
	mergeVeeValidateMst("en", en);
	mergeVeeValidateMst("ja", ja);

	return comMsg;
}

export { getCombinedMessages }